import { api } from '@/shared/api/api-client';
import { ENDPOINTS } from '@/shared/api/endpoints';

export interface AssistantMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface AssistantReply {
  enabled: boolean;
  reply: string;
  creditsRemaining: number | null;
}

export function sendAssistantMessage(
  messages: AssistantMessage[],
): Promise<AssistantReply> {
  return api().post<AssistantReply>(ENDPOINTS.me.assistant, { messages });
}
